import { render, staticRenderFns } from "./MigrationNotificationBanner.vue?vue&type=template&id=e5d62ae0&scoped=true&"
import script from "./MigrationNotificationBanner.vue?vue&type=script&lang=js&"
export * from "./MigrationNotificationBanner.vue?vue&type=script&lang=js&"
import style0 from "./MigrationNotificationBanner.vue?vue&type=style&index=0&id=e5d62ae0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5d62ae0",
  null
  
)

export default component.exports